interface Props {
	onOpen: () => void;
}

const ChatBotLauncher = ({ onOpen }: Props) => (
	<button className='chatBot--launcher' onClick={onOpen}>
		<span className='chatBot--launcher-icon'>
			<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeWidth="2"
				style={{ width: 22, height: 22, flexShrink: 0 }}>
				<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
				<path d="M19 3l.6 1.8L21 5.4l-1.4.6L19 7.8l-.6-1.8L17 5.4l1.4-.6z" />
			</svg>
		</span>
		<span className='chatBot--launcher-label'>Ask NovaForce</span>

		{/**/}
		{/* <span className='chatBot--launcher-kbd'>⌘J</span> */}
		{/**/}

	</button>
);

export default ChatBotLauncher;
